import { Box, FormLabel, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { useCallback } from "react";
import { TextStyleProps } from "../types/formConfig";

interface RadioOption {
    value: string;
    label: string;
}

interface FormRadioGroupProps {
    fieldPath: string;
    label?: string;
    value: string;
    options: RadioOption[];
    handleFieldChange: (fieldPath: string, value: any) => void;
    labelStyle?: TextStyleProps;
}

const FormRadioGroup = ({ fieldPath, label, value, options, handleFieldChange, labelStyle }: FormRadioGroupProps) => {
    const handleChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement>) => {
            handleFieldChange(fieldPath, event.target.value);
        },
        [fieldPath, handleFieldChange],
    );

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
            {label && <FormLabel>{label}</FormLabel>}
            <RadioGroup
                row
                value={value}
                onChange={handleChange}
            >
                {options.map((option) => (
                    <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={<Radio size="small" />}
                        label={option.label}
                        sx={labelStyle ? { "& .MuiFormControlLabel-label": labelStyle } : undefined}
                    />
                ))}
            </RadioGroup>
        </Box>
    );
};

export default FormRadioGroup;
